import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=6d2786f5&scoped=true"
import script from "./Safety.vue?vue&type=script&lang=js"
export * from "./Safety.vue?vue&type=script&lang=js"
import style0 from "./Safety.vue?vue&type=style&index=0&id=6d2786f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2786f5",
  null
  
)

export default component.exports